import WatcherTransactionCard from "components/Dashboard/Watcher/utils/Cards/WatcherTransactionCard/WatcherTransactionCard";
import { watcherTransactionData } from "components/Dashboard/Watcher/utils/data";
import "./WatcherTransactions.scss";

const WatcherTransactions = () => {
	return (
		<div className="watcher-reg">
			<div className="container-fluid">
				<div className="row">
					<div className="col-4 p-2">
						<div className="col-inner p-4">
							<div className="flex__between">
								<div className="title">
									<h5>Pending Transactions</h5>
								</div>
								<div className="tag">
									<h5>235</h5>
								</div>
							</div>
							<div className="col-inner-body pt-4">
								{watcherTransactionData.map((data, i) => (
									<WatcherTransactionCard
										key={i}
										watcher={data}
									/>
								))}
							</div>
						</div>
					</div>

					<div className="col-4 p-2">
						<div className="col-inner p-4">
							<div className="flex__between">
								<div className="title">
									<h5>Failed Transactions</h5>
								</div>
								<div className="tag">
									<h5>235</h5>
								</div>
							</div>
							<div className="col-inner-body pt-4">
								{watcherTransactionData.map((data, i) => (
									<WatcherTransactionCard
										key={i}
										watcher={data}
									/>
								))}
							</div>
						</div>
					</div>

					<div className="col-4 p-2">
						<div className="col-inner p-4">
							<div className="flex__between">
								<div className="title">
									<h5>Successfull Transactions</h5>
								</div>
								<div className="tag">
									<h5>235</h5>
								</div>
							</div>

							<div className="col-inner-body pt-4">
								{watcherTransactionData.map((data, i) => (
									<WatcherTransactionCard
										key={i}
										watcher={data}
									/>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default WatcherTransactions;
